import React from 'react'

import {
  AlignItems,
  Body2,
  Box,
  Color,
  Display,
  FlexDirection,
  FontFamily,
  JustifyContent,
  Text,
  TextAlign,
} from '@gousto-internal/citrus-react'

type RecipePlaceholderProps = {
  basketPosition: number
  pricePerServing?: string | null
}

export const RecipePlaceholder = ({ basketPosition, pricePerServing }: RecipePlaceholderProps) => (
  <Box
    alignItems={AlignItems.Center}
    bg={Color.NeutralGrey_50}
    display={Display.Flex}
    flexDirection={FlexDirection.Column}
    height={['60px', '50px']}
    justifyContent={JustifyContent.Center}
    paddingH={0.5}
    paddingBottom={0.5}
    width="100%"
  >
    <Body2 fontFamily={FontFamily.Bold}>{basketPosition}</Body2>
    {pricePerServing && (
      <Text textAlign={TextAlign.Center} style={{ fontSize: '10px', lineHeight: '12px' }}>
        for £{pricePerServing} <br /> per serving
      </Text>
    )}
  </Box>
)
